import React from 'react';
import { ReferenceInput, useLocaleState } from 'react-admin';
import { AutocompleteInput } from './wrappers/Inputs';

const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

const LanguageSelector = ({ formData }) => {
    const [_locale, setLocale] = useLocaleState();
    const chooseLanguage = () =>
        sleep(50).then(() => {
            return formData.languageId === 'LAN000002'
                ? setLocale('cy')
                : setLocale('en');
        });
    return (
        <ReferenceInput reference="Language" source="languageId" fullWidth>
            <AutocompleteInput
                optionText="description"
                onClick={chooseLanguage}
            />
        </ReferenceInput>
    );
};

export default LanguageSelector;
